import { FlowinglyPermissions } from '@Shared.Angular/flowingly.services/flowingly.constants';
import { SharedAngular } from '../../@types/sharedAngular';
import angular from 'angular';
import { IStateService } from 'angular-ui-router';

angular.module('flowingly.runner.setup').config(config);
config.$inject = ['$stateProvider'];

function config($stateProvider) {
  $stateProvider.state('app.runner.setup.taggroups', {
    url: '/tags',
    params: { flowId: null, title: 'Setup - Tags' },
    views: {
      childcontent: {
        controllerAs: '$ctrl',
        controller: [
          'permissionsService',
          '$state',
          'pubsubService',
          function (
            permissionsService: SharedAngular.PermissionsService,
            $state: IStateService,
            pubsubService: SharedAngular.PubSubService
          ) {
            const $ctrl = this;
            if (
              !permissionsService.currentUserHasAnyOfPermissions([
                FlowinglyPermissions.SETUP_TAG_ACCESS,
                FlowinglyPermissions.SETUP_TAG_UPDATE
              ])
            ) {
              $state.go('app.runner.flowsactive');
            }

            this.onAddButtonClick = function () {
              pubsubService.publish('SETUP_TAGGROUP_ADD_CLICKED');
            };
          }
        ],
        templateUrl:
          'Client/runner.setup/runner.setup.taggroups/runner.setup.taggroups.tmpl.html'
      }
    }
  });
}
